import { StyledModalComponent } from '@dnhb/node_package';
import PropTypes from 'prop-types';
import { useMemo, useState, memo } from 'react';
import analytics from '../utility/analytics';
import { PrimaryButton, PrimaryOutlineButton } from '../buttons';
import { LeadFormRedux } from './';

const LeadFormUrlButton = memo(({ leadButtonUrl, leadButtonText, urlLeadFormParams, renderAs, useAddedUrlParams }) => {
  const Button = renderAs === 'PrimaryButton' ? PrimaryButton : PrimaryOutlineButton;
  const httpsUrl = leadButtonUrl.startsWith('http') ? leadButtonUrl : `https://${leadButtonUrl}`;
  const url = useAddedUrlParams ? httpsUrl + urlLeadFormParams : httpsUrl;

  return (
    <Button onClick={() => (analytics.send('Open', 'externe pagina'), window.open(url, '_top'))} type="button">
      {leadButtonText}
    </Button>
  );
});

const LeadRequestButton = ({ app, settings, renderAs, handleSubmit, LeadForm = LeadFormRedux, urlLeadFormParams }) => {
  const { leadButtonUrl, leadButtonText, useAddedUrlParams } = settings;
  const [showLeadForm, setShowLeadForm] = useState(false);
  const [formIsLoading, setFormIsLoading] = useState(false);
  const toolElement = useMemo(() => document.getElementById(`${app}-app`), [app]);
  const Button = renderAs === 'PrimaryButton' ? PrimaryButton : PrimaryOutlineButton;
  const closeModal = () => setShowLeadForm(false);

  return (
    <>
      {!leadButtonUrl ? (
        <Button onClick={() => (analytics.send('Open', 'leadform'), setShowLeadForm(true))} type="button">
          {leadButtonText}
        </Button>
      ) : (
        <LeadFormUrlButton {...{ leadButtonUrl, leadButtonText, renderAs, urlLeadFormParams, useAddedUrlParams }} />
      )}

      <StyledModalComponent
        appElement={toolElement}
        isOpen={showLeadForm}
        onRequestClose={formIsLoading ? () => {} : closeModal}
        maxWidth={540}
        showCross={false}
      >
        <LeadForm
          app={app}
          onRequestClose={() => setShowLeadForm(false)}
          formIsLoading={formIsLoading}
          setFormIsLoading={setFormIsLoading}
          settings={settings}
          handleSubmit={handleSubmit}
        />
      </StyledModalComponent>
    </>
  );
};

LeadRequestButton.propTypes = {
  app: PropTypes.string.isRequired,
  settings: PropTypes.shape({}).isRequired,
  handleSubmit: PropTypes.func,
  renderAs: PropTypes.oneOf(['PrimaryButton', 'PrimaryOutlineButton']),
  LeadForm: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

LeadRequestButton.defaultProps = {
  renderAs: 'PrimaryButton',
  handleSubmit: () => {},
};

export default LeadRequestButton;
